import { CommonHelperFunctions } from "@kuika/kuika-cl-model";

// ── MCP Chat Configuration ──
// Externalized constants for the MCP chat panel.

/** Base URL for the mcp-chat-server (chat proxy, health, WebSocket bridge). */
export const MCP_CHAT_API_URL: string = `${CommonHelperFunctions.GetAiChatUrl()}/api`;

/** @deprecated Use MCP_CHAT_API_URL instead. Kept for backwards compatibility. */
export const MCP_CHAT_URL: string = MCP_CHAT_API_URL;

/** How often (ms) to poll the /health endpoint when the panel is open. */
export const HEALTH_POLL_INTERVAL = 5000;

/** Maximum number of simultaneous chat tabs. */
export const MAX_TABS = 8;

/** Number of messages to render per "page" in the virtual scroll. */
export const MESSAGES_PAGE_SIZE = 25;

/** Maximum number of images that can be attached to a single message. */
export const MAX_ATTACHED_IMAGES = 5;

/** Maximum number of document files that can be attached to a single message. */
export const MAX_ATTACHED_FILES = 3;

/** Maximum file size in bytes (10 MB). */
export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;

/** Human-readable label for MAX_FILE_SIZE_BYTES, used in error messages and UI hints. */
export const MAX_FILE_SIZE_LABEL = "10 MB";

/** Allowed file extensions for document attachments. */
export const ALLOWED_FILE_EXTENSIONS = ["pdf", "docx", "xlsx", "csv", "txt", "json", "xml", "html", "htm"];

/** Accept string for the document file input. */
export const ALLOWED_FILE_ACCEPT = ".pdf,.docx,.xlsx,.csv,.txt,.json,.xml,.html,.htm";

/** localStorage key for persisted panel dimensions. */
export const PANEL_SIZE_STORAGE_KEY = "kuika_mcp_chat_size";

/** How often (ms) to poll for context pill updates. */
export const CONTEXT_PILL_POLL_INTERVAL = 1500;

/** Returns true when the app is running on the public platform (design-only restrictions apply). */
export const isPlatformMode = (): boolean => false;

/** Distance (px) within which the panel snaps to an anchor zone during drag. */
export const ANCHOR_SNAP_DISTANCE = 80;

/** localStorage key for persisted chat anchor position. */
export const PANEL_ANCHOR_STORAGE_KEY = "kuika_mcp_chat_anchor";

/** Panel minimum dimensions (px) — vertical (portrait) orientation. */
export const PANEL_MIN_WIDTH = 430;

/** Panel width (px) below which compact mode activates (icon-only header, collapsed pills). */
export const PANEL_COMPACT_THRESHOLD = 360;
export const PANEL_MIN_HEIGHT = 360;

/** Panel maximum dimensions — computed from viewport so the panel can fill the screen on large/zoomed-out displays. */
export const getPanelMaxWidth = (): number => Math.max(800, window.innerWidth - 120);
export const getPanelMaxHeight = (): number => Math.max(900, window.innerHeight - 64);

/** Panel minimum dimensions (px) — horizontal (landscape) orientation for top/bottom anchors. */
export const PANEL_HORIZONTAL_MIN_WIDTH = 500;
export const PANEL_HORIZONTAL_MIN_HEIGHT = 250;
export const PANEL_HORIZONTAL_DEFAULT_HEIGHT = 300;

/** Horizontal panel maximum dimensions — computed from viewport. */
export const getPanelHorizontalMaxWidth = (): number => Math.max(1600, window.innerWidth - 120);
export const getPanelHorizontalMaxHeight = (): number => Math.max(500, window.innerHeight - 120);

/** localStorage key for persisted horizontal panel dimensions. */
export const PANEL_HORIZONTAL_SIZE_STORAGE_KEY = "kuika_mcp_chat_size_horizontal";
